
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/budgeting",
      function () {
        return require("private-next-pages/compare/budgeting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/budgeting"])
      });
    }
  